export default {
  default: () => import("/builds/webcontact/burgbernheim/layouts/default.vue"),
  stadtwerke: () => import("/builds/webcontact/burgbernheim/layouts/stadtwerke.vue")
}